export function AllowPatternDirective(UtilService) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      let utils = new UtilService(scope);
      utils.validatePattern(element, attrs.allowPattern);
    },
  };
}

AllowPatternDirective.$inject = ['UtilService'];
